/**
 * <s-countdown> — live countdown to a fixed end time, shown as "3D 21:14:08", or "21:14:08" under a day.
 *
 * Attributes:
 *   data-end   — ISO 8601 end time
 *   data-units — comma-separated translated unit labels; the first is the day suffix
 */
class SCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.end = Date.parse(this.dataset.end);
    this.daySuffix = (this.dataset.units || 'D').split(',')[0];
    if (Number.isNaN(this.end)) return;
    this.#tick();
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
  }

  #tick() {
    const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
    const pad = (n) => String(n).padStart(2, '0');
    const days = Math.floor(remaining / 86400);
    const hours = Math.floor((remaining % 86400) / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;
    const hasDays = days > 0;
    const dayPart = hasDays ? `${days}${this.daySuffix} ` : '';
    const changedShape = this.dataset.shape !== String(hasDays);
    this.dataset.shape = String(hasDays);
    // Write into an inner SVG <text> when present (the promo bar), otherwise into the element itself.
    const target = this.querySelector('[data-countdown-text]') || this;
    target.textContent = `${dayPart}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    if (changedShape) this.dispatchEvent(new CustomEvent('countdown:reshape', { bubbles: true }));
    if (remaining > 0) this.#timer = setTimeout(() => this.#tick(), 1000 - (Date.now() % 1000));
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
